export default {
    main: '0.2s ease-in'
}
